import firebase from "firebase/app";

export const createMoodsSetCollectionRef = () =>
  firebase.firestore().collection("moodsSets");
export const createUserMoodsSetCollectionQuery = userId =>
createMoodsSetCollectionRef().where("userId", "==", userId);
